<template>
  <div class="container-fluid py-4">
    <!-- Header clinique -->
    <div class="d-flex justify-content-between align-items-center mb-4 header-clinique">
      <div class="d-flex align-items-center gap-3">
        <i class="bi bi-pencil-square fs-2 text-primary"></i>
        <h2 class="fw-bold mb-0">Modification d'un Type d'Examen</h2>
      </div>
      <router-link class="btn btn-primary btn-lg shadow-sm btn-clinique" :to="{ name: 'liste_type_examen' }">
        <i class="bi bi-arrow-left-circle me-2"></i>
      </router-link>
    </div>

    <!-- Card formulaire -->
    <div class="card p-4 shadow-sm rounded card-clinique">
      <div v-if="isLoading" class="text-center my-5">
        <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
          <span class="visually-hidden">Chargement...</span>
        </div>
        <p class="mt-2">Chargement du type d'examen...</p>
      </div>

      <div v-else>
        <div class="row g-4">
          <!-- Nom -->
          <div class="col-md-6">
            <label for="nom" class="form-label fw-semibold">Nom</label>
            <input
              type="text"
              id="nom"
              v-model="typeExamen.nom"
              class="form-control form-control-clinique"
              :class="{ 'is-invalid': error.nom }"
              placeholder="Ex : Examen sanguin"
            >
            <div class="invalid-feedback">{{ error.nom }}</div>
          </div>
        </div>

        <!-- Statut -->
        <div class="row g-4 mt-1">
          <div class="col-md-6 d-flex align-items-center">
            <div class="form-check form-switch">
              <input class="form-check-input" type="checkbox" id="enabled" v-model="typeExamen.isEnabled">
              <label class="form-check-label ms-2 fw-semibold" for="enabled">
                Activé ?
              </label>
            </div>
          </div>
        </div>

        <!-- Boutons -->
        <div class="d-flex justify-content-end gap-3 mt-4">
          <button class="btn btn-light border shadow-sm px-4 py-2" @click="cancel">
            <i class="bi bi-x-circle me-1"></i> Annuler
          </button>
          <button class="btn btn-success shadow px-4 py-2 btn-clinique" :disabled="isSaving" @click="updateTypeExamen">
            <i class="bi bi-save me-1"></i>
            <span v-if="isSaving">Enregistrement...</span>
            <span v-else>Mettre à jour</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api';

export default {
  name: 'EditTypeExamen',
  data() {
    return {
      isLoading: true,
      isSaving: false,
      typeExamen: {
        nom: '',
        isEnabled: true
      },
      error: {
        nom: ''
      }
    };
  },
  async created() {
    await this.fetchTypeExamen();
  },
  methods: {
    async fetchTypeExamen() {
      const id = this.$route.params.id;
      try {
        const res = await api.getItem('type_examens', id);
        this.typeExamen = {
          nom: res.data.nom,
          isEnabled: res.data.isEnabled
        };
      } catch (err) {
        console.error("Erreur de chargement du type d'examen", err);
        alert("Impossible de charger le type d'examen.");
        this.$router.push({ name: 'liste_type_examen' });
      } finally {
        this.isLoading = false;
      }
    },
    validateForm() {
      this.error = {
        nom: this.typeExamen.nom ? '' : 'Le nom est requis'
      };
      return !Object.values(this.error).some(err => err !== '');
    },
    async updateTypeExamen() {
      if (!this.validateForm() || this.isSaving) return;
      const id = this.$route.params.id;
      try {
        this.isSaving = true;
        await api.updateItem('type_examens', id, this.typeExamen);
        alert('Type d\'examen mis à jour avec succès !');
        this.$router.push({ name: 'liste_type_examen' });
      } catch (error) {
        console.error('Erreur lors de la mise à jour du type d\'examen', error);
        alert("Une erreur s'est produite lors de l'enregistrement.");
      } finally {
        this.isSaving = false;
      }
    },
    cancel() {
      this.$router.push({ name: 'liste_type_examen' });
    }
  }
};
</script>

<style scoped>
.header-clinique {
  padding: 15px 20px;
  background-color: #e9f5ff;
  border-radius: 12px;
  margin-bottom: 20px;
}

.card-clinique {
  background: #f8fafd;
  border-radius: 12px;
  border: none;
}

.form-control-clinique {
  border-radius: 10px;
  border: 1px solid #d1e3f0;
  padding: 10px 14px;
  transition: all 0.3s ease;
}
.form-control-clinique:focus {
  box-shadow: 0 0 6px #0d6efd33;
  border-color: #0d6efd;
}

.btn-clinique {
 background: linear-gradient(90deg, #0d6efd, #6610f2);
  border: none;
  color: #fff;
  border-radius: 10px;
  transition: all 0.3s ease;
}
.btn-clinique:hover {
  box-shadow: 0 5px 15px rgba(0,0,0,0.2);
  transform: translateY(-2px);
}
</style>
